// extracted by mini-css-extract-plugin
export var dropdownContainer = "_pa-0";
export var leftAlign = "_pa-4";
export var listItem = "_pa-2";
export var listItemWrapper = "_pa-1";
export var operationText = "_pa-3";